
document.addEventListener("DOMContentLoaded", function() {
    const video = document.getElementById("home-video");
    const button = document.getElementById("mute-toggle");

    if (video && button) {
        // état initial
        if (video.muted) {
            button.classList.add("mute");
        }

        button.addEventListener("click", function() {
            video.muted = !video.muted;
            button.classList.toggle("mute", video.muted);
        });
    }
});